$(function () {
    // Save existing sort parameters
    Shopify.queryParams = {};
    if (location.search.length) {
        for (
            var aKeyValue,
                i = 0,
                aCouples = location.search.substr(1).split("&");
            i < aCouples.length;
            i++
        ) {
            aKeyValue = aCouples[i].split("=");
            if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
                    decodeURIComponent(aKeyValue[1]);
            }
        }
    }

    // Add existing sort parameters to current URL
    // var sortBy = document.querySelector('#SortBy')
    // if (sortBy) {
    //     sortBy.addEventListener('change', function(e) {
    //         var value = e.currentTarget.value;
    //         Shopify.queryParams.sort_by = value;
    //         location.search = new URLSearchParams(Shopify.queryParams).toString();
    //     });
    // }

    // // Add existing sort parameters to current URL
    // var productNo = document.querySelector('#ProductNo')
    // if (productNo) {
    //     productNo.addEventListener('change', function(e) {
    //         var value = e.currentTarget.value;
    //         Shopify.queryParams.view = value;
    //         location.search = new URLSearchParams(Shopify.queryParams).toString();
    //     });
    // }

    // const MAX_QTY = parseInt($('[data-qty-max]').val())

    // $('[data-qty-decrease]').on('click', function(e){
    //     e.preventDefault()
    //     const input = $('[data-qty]')
    //     var value = input.val();
    //     if (value > 1) {
    //         value--;
    //     }
    //     input.val(value);
    // })

    // $('[data-qty-increase]').on('click', function(e){
    //     e.preventDefault()
    //     const input = $('[data-qty]')
    //     var value = input.val();
    //     if (value != MAX_QTY) {
    //         value++;
    //         input.val(value);
    //     }
    // })

    // $('input[type="search"]').on('keyup', function(){
    //     let length = $(this).val().length
    //     if (length > 0) {
    //         $('[data-search-icon]').addClass('hidden')
    //     } else {
    //         $('[data-search-icon]').removeClass('hidden')
    //     }
    // })

    // $('input[type="search"]').on('click', function(){
    //     let length = $(this).val().length
    // })

    // $('[data-clear-filter]').on('click', function(e){
    //     e.preventDefault()
    //     window.location = window.location.href.split('?')[0];
    // })

    $("[data-search-toggle]").on("click", function (e) {
        $("[data-search-full]").slideToggle();
        $('input[type="search"]').focus();
    });

    $("[data-top]").on("click", function (e) {
        e.preventDefault();
        // Scroll to it
        window.scroll({
            top: 0,
            behavior: "smooth",
        });
        // Fix for IE's not liking window.scroll
        if (theme.oldBrowsers.isIE11 || theme.oldBrowsers.isIE10Down) {
            $("html, body").animate(
                {
                    scrollTop: 0,
                },
                1000
            );
        }
    });
});
